<template lang="html">
  <div id="tour-description-page">

    <section class="banners-section">
      <swiper class="swiper" :options="bannersOptions">
        <swiper-slide>
          <div class="placed-backg box-image" v-bind:style="{ backgroundImage: 'url('+tour.image+')' }"></div>
        </swiper-slide>
      </swiper>

      <div class="box-content">
        <div class="container">
          <div class="row">
            <div class="col-12 col-content">
              <h6 class="title-1">EXPLORE</h6>
              <h3 class="name">{{ tour.name }}</h3>
              <!-- <h4 class="title-2">Private boat + snorkel in 2 islands</h4> -->
              <div class="box-short-description">
                <h4 class="title-3">{{ tour.short_description }}</h4>
              </div>

              <div class="box-buttons">
                <router-link class="btn btn-s1" to="/booking">Check availability</router-link>
                <router-link class="btn btn-s2" to="/booking">Book now!</router-link>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>

    <section class="main-section">
      <div class="container oversized-container">
        <div class="row justify-content-center">
          <div class="col-lg-10 col-content">
            <div class="box-content">
              <!-- <div class="box-breadcrumb">
                <router-link class="t-150 link-back" to=""><i class="fas fa-chevron-left icon"></i> EXCLUSIVE PRIVATE TOUR AT COZUMEL</router-link>
              </div> -->

              <div class="box-short-info mt-0">
                <h3 class="name">{{ tour.name }}</h3>
                <div class="box-prices">
                  <div class="b-price">
                    <h4 class="price">$ {{ Intl.NumberFormat("en-US", { minimumFractionDigits: 2 }).format(tour.one_guest) }}</h4>
                    <span class="symbol">/</span>
                    <span class="txt">1 Guest</span>
                  </div>

                  <div class="b-price">
                    <h4 class="price">$ {{ Intl.NumberFormat("en-US", { minimumFractionDigits: 2 }).format(tour.two_guest) }}</h4>
                    <span class="symbol">/</span>
                    <span class="txt">2 Guests</span>
                  </div>

                  <div class="b-show-more">
                    <a class="t-250" @click="$refs['modal-prices'].show();"><i class="fa-sharp fa-regular fa-list"></i> See all prices</a>
                  </div>
                </div>

                <!-- <div class="b-stars">
                  <b-form-rating inline value="4" disabled></b-form-rating>
                  <span class="txt">(2.3k review)</span>
                </div> -->
              </div>

              <div class="row box-main-content">
                <div class="col-xl-7 col-information">
                  <div class="b-info">
                    <p v-html="tour.description"></p>
                  </div>

                  <div class="box-table">
                    <div class="row">
                      <div class="col col-lab">Availability days</div>
                      <div class="col col-info">
                        <span class="b-days" v-if="tour.monday == 1">Monday</span>
                        <span class="b-days" v-if="tour.tuesday == 1">Tuesday</span>
                        <span class="b-days" v-if="tour.wednesday == 1">Wednesday</span>
                        <span class="b-days" v-if="tour.thursday == 1">Thursday</span>
                        <span class="b-days" v-if="tour.friday == 1">Friday</span>
                        <span class="b-days" v-if="tour.saturday == 1">Saturday</span>
                        <span class="b-days" v-if="tour.sunday == 1">Sunday</span>
                      </div>
                    </div>

                    <div class="row">
                      <div class="col col-lab">Pickup locations</div>
                      <div class="col col-info">{{ tour.pickup_locations }}</div>
                    </div>

                    <div class="row">
                      <div class="col col-lab">Start time</div>
                      <div class="col col-info">Approximately {{ tour.time_start }}</div>
                    </div>

                    <div class="row">
                      <div class="col col-lab">End time</div>
                      <div class="col col-info">Approximately {{ tour.time_end }}</div>
                    </div>

                    <div class="row">
                      <div class="col col-lab">Average duration</div>
                      <div class="col col-info">{{ tour.duration_hours }} <span v-if="tour.duration_hours <= 1">hour</span><span v-else>hours</span></div>
                    </div>

                    <div class="row">
                      <div class="col col-lab">What to bring</div>
                      <div class="col col-info">{{ tour.what_bring }}</div>
                    </div>

                    <div class="row">
                      <div class="col col-lab">Activities</div>
                      <div class="col col-info">{{ tour.activities }}</div>
                    </div>

                    <div class="row">
                      <div class="col col-lab">Additional information</div>
                      <div class="col col-info">{{ tour.additional_information }}</div>
                    </div>

                    <div class="row" style="min-height: 30px;">
                      <div class="col col-lab">Food included</div>
                      <div class="col col-info">
                        <span v-if="tour.food == 1">YES</span>
                        <span v-else>NO</span>
                      </div>
                    </div>

                    <div class="row">
                      <div class="col col-lab">Included</div>
                      <div class="col col-info" v-html="tour.whats_includes">
                        <!-- <div class="b-tag"><i class="far fa-check-circle icon"></i> 5 star accomodations</div>
                        <div class="b-tag"><i class="far fa-check-circle icon"></i> Airport transfer</div>
                        <div class="b-tag"><i class="far fa-check-circle icon"></i> Breakfast</div>
                        <div class="b-tag"><i class="far fa-check-circle icon"></i> Personal guide</div> -->
                      </div>
                    </div>

                    <div class="row">
                      <div class="col col-lab">Visit our album</div>
                      <div class="col col-info">
                        <a target="_blank" class="_link" :href="tour.picture_album">Click here!</a>
                      </div>
                    </div>
                  </div>
                </div>

                <div class="col-xl-5 col-faqs">
                  <div class="box">
                    <h5 class="title">ADD-ONS</h5>

                    <div class="accordion" role="tablist">
                      <b-card no-body v-if="f.q" v-for="(f, fInx) in faqs" :key="'fInx-'+fInx">
                        <b-card-header header-tag="header" role="tab">
                          <a v-b-toggle="'accordion-'+fInx">{{ f.q }}</a>
                        </b-card-header>

                        <b-collapse :id="'accordion-'+fInx" accordion="accordion-faqs" role="tabpanel">
                          <b-card-body>
                            <p v-if="f.pricePerson">
                              Price per person: <strong>${{ Intl.NumberFormat("en-US", { minimumFractionDigits: 2 }).format(f.pricePerson) }}</strong>
                            </p>
                            <p v-if="f.priceService">
                              Price per service: <strong>${{ Intl.NumberFormat("en-US", { minimumFractionDigits: 2 }).format(f.priceService) }}</strong>
                            </p>
                          </b-card-body>
                        </b-collapse>
                      </b-card>
                    </div>
                  </div>

                  <div class="box-buttons">
                    <router-link class="btn btn-s1 s-2" to="/booking">Check availability</router-link>
                    <router-link class="btn btn-s2" to="/booking">Book now!</router-link>
                  </div>
                </div>

                <!-- <div class="col-xl-7 col-gallery">
                  <h3 class="title-s2">From our gallery</h3>

                  <div class="b-description">
                    <p>
                      Ex optio sequi et quos praesentium in nostrum labore nam rerum iusto aut magni nesciunt? Quo quidem neque iste expedita est dolor similique ut quasi maxime ut deserunt autem At praesentium voluptatem aut libero nisi.
                    </p>
                  </div>

                  <div class="b-gallery">
                    <div class="col-6 col-lg-4 col-image" v-for="(g, gInx) in gallery" :key="'gInx-'+gInx">
                      <img class="t-150 placed-backg" src="public/images/empty.png" v-bind:style="{ backgroundImage: 'url('+g.src+')' }" @click="setIndex(gInx)">
                    </div>
                  </div>
                </div> -->
              </div>

              <div class="box-related">
                <div class="row box-top">
                  <div class="col-md-8 col-title">
                    <h2 class="title-s2">Related tours</h2>
                  </div>

                  <div class="col-md-4 col-buttons">
                    <router-link class="t-150" to="/tours">View all tours</router-link>
                  </div>
                </div>

                <div class="box-tours">
                  <swiper class="swiper" :options="relatedOptions">
                    <swiper-slide v-for="(tour, thInx) in tours" :key="'thInx-'+thInx">
                      <div class="col-12 px-0 col-tour-s1">
                        <router-link class="box-link" :to="'/tour/'+$root._converToURL(tour.name, tour.id)">
                          <div class="box-image">
                            <img class="placed-backg" src="public/images/pages/tours/tour.png" v-bind:style="{ backgroundImage: 'url('+tour.image+')' }">
                          </div>

                          <div class="box-info">
                            <!-- <h6 class="days"><i class="fa-light fa-calendar icon"></i> 8 Days</h6> -->
                            <h6 class="available-days">
                              <i class="fa-light fa-calendar icon"></i> 
                              <span class="pr-1">Availability: </span>
                              <small v-if="tour.monday == 1">Mo,</small>
                              <small v-if="tour.tuesday == 1">Tu,</small>
                              <small v-if="tour.wednesday == 1">We,</small>
                              <small v-if="tour.thursday == 1">Th,</small>
                              <small v-if="tour.friday == 1">Fr,</small>
                              <small v-if="tour.saturday == 1">Sa,</small>
                              <small v-if="tour.sunday == 1">Su</small>
                            </h6>

                            <h4 class="name">{{ tour.name }}</h4>

                            <!-- <div class="b-stars">
                              <b-form-rating inline value="4" readonly></b-form-rating>
                            </div> -->

                            <div class="b-price">
                              <h5 class="price">$ {{ Intl.NumberFormat("en-US", { minimumFractionDigits: 2 }).format(tour.one_guest) }}</h5>
                              <!-- <h5 class="price old-price">{{ Intl.NumberFormat("en-US", { minimumFractionDigits: 2 }).format(tour.oldPrice) }} $</h5> -->
                            </div>

                            <div class="b-description">
                              <p>
                                {{ tour.short_description }}
                              </p>
                            </div>

                            <a class="btn-explore">Explore Now</a>
                          </div>
                        </router-link>
                      </div>
                    </swiper-slide>

                    <div class="swiper-pagination" slot="pagination"></div>
                  </swiper>
                </div>
              </div>

              <!-- <div class="box-products">
                <div class="row box-top">
                  <div class="col-md-8 col-title">
                    <h2 class="title-s2">Complementary products</h2>
                  </div>

                  <div class="col-md-4 col-buttons">
                    <router-link class="t-150" to="/products">View all products</router-link>
                  </div>
                </div>

                <div class="b-products">
                  <swiper class="swiper" :options="relatedOptions">
                    <swiper-slide v-for="(a, pInx) in products" :key="'pInx-'+pInx">
                      <div class="col-12 px-0 col-product-s1">
                        <router-link class="box-link" to="/products/1">
                          <div class="box-image">
                            <img class="placed-backg" src="public/images/pages/products/product.png" v-bind:style="{ backgroundImage: 'url('+a.imageUrl+')' }">
                          </div>
                          <div class="box-info">
                            <h5 class="name">{{ a.name }}</h5>
                            <h5 class="price">$350.00</h5>
                          </div>

                          <div class="box-buttons">
                            <a class="btn-shop">Shop Now</a>
                          </div>
                        </router-link>
                      </div>
                    </swiper-slide>

                    <div class="swiper-pagination" slot="pagination"></div>
                  </swiper>
                </div>
              </div> -->
            </div>
          </div>
        </div>
      </div>
    </section>

    <CoolLightBox
      :items="gallery"
      :index="index"
      :effect="'fade'"
      loop
      @close="index = null">
    </CoolLightBox>

    <b-modal modal-class="modal-prices" ref="modal-prices" size="sm" hide-footer centered title="">
      <div class="box-title">
        <h5>View all tours</h5>
      </div>

      <div class="box-prices">
        <div class="row row-price-info">
          <div class="col col-text">1 guest</div>
          <div class="col col-price">${{ Intl.NumberFormat("en-US", { minimumFractionDigits: 2 }).format(tour.one_guest) }}</div>
        </div>

        <div class="row row-price-info">
          <div class="col col-text">2 guests</div>
          <div class="col col-price">${{ Intl.NumberFormat("en-US", { minimumFractionDigits: 2 }).format(tour.two_guest) }}</div>
        </div>

        <div class="row row-price-info">
          <div class="col col-text">3 guests</div>
          <div class="col col-price">${{ Intl.NumberFormat("en-US", { minimumFractionDigits: 2 }).format(tour.three_guest) }}</div>
        </div>

        <div class="row row-price-info">
          <div class="col col-text">4 guests</div>
          <div class="col col-price">${{ Intl.NumberFormat("en-US", { minimumFractionDigits: 2 }).format(tour.four_guest) }}</div>
        </div>

        <div class="row row-price-info">
          <div class="col col-text">5 guests</div>
          <div class="col col-price">${{ Intl.NumberFormat("en-US", { minimumFractionDigits: 2 }).format(tour.five_guest) }}</div>
        </div>

        <div class="row row-price-info">
          <div class="col col-text">6 guests</div>
          <div class="col col-price">${{ Intl.NumberFormat("en-US", { minimumFractionDigits: 2 }).format(tour.six_guest) }}</div>
        </div>

        <div class="row row-price-info">
          <div class="col col-text">7 guests</div>
          <div class="col col-price">${{ Intl.NumberFormat("en-US", { minimumFractionDigits: 2 }).format(tour.seven_guest) }}</div>
        </div>

        <div class="row row-price-info">
          <div class="col col-text">8 guests</div>
          <div class="col col-price">${{ Intl.NumberFormat("en-US", { minimumFractionDigits: 2 }).format(tour.eight_guest) }}</div>
        </div>

        <div class="row row-price-info">
          <div class="col col-text">9 guests</div>
          <div class="col col-price">${{ Intl.NumberFormat("en-US", { minimumFractionDigits: 2 }).format(tour.nine_guest) }}</div>
        </div>

        <div class="row row-price-info">
          <div class="col col-text">10 guests</div>
          <div class="col col-price">${{ Intl.NumberFormat("en-US", { minimumFractionDigits: 2 }).format(tour.ten_guest) }}</div>
        </div>

        <div class="row row-price-info">
          <div class="col col-text">11 guests</div>
          <div class="col col-price">${{ Intl.NumberFormat("en-US", { minimumFractionDigits: 2 }).format(tour.eleven_guest) }}</div>
        </div>

        <div class="row row-price-info">
          <div class="col col-text">12 guests</div>
          <div class="col col-price">${{ Intl.NumberFormat("en-US", { minimumFractionDigits: 2 }).format(tour.twelve_guest) }}</div>
        </div>

        <div class="row row-price-info">
          <div class="col col-text">13 guests</div>
          <div class="col col-price">${{ Intl.NumberFormat("en-US", { minimumFractionDigits: 2 }).format(tour.thirteen_guest) }}</div>
        </div>

        <div class="row row-price-info">
          <div class="col col-text">14 guests</div>
          <div class="col col-price">${{ Intl.NumberFormat("en-US", { minimumFractionDigits: 2 }).format(tour.fourteen_guest) }}</div>
        </div>

        <div class="row row-price-info">
          <div class="col col-text">15 guests</div>
          <div class="col col-price">${{ Intl.NumberFormat("en-US", { minimumFractionDigits: 2 }).format(tour.fiveteen_guest) }}</div>
        </div>

        <div class="row row-price-info">
          <div class="col col-text">16 guests</div>
          <div class="col col-price">${{ Intl.NumberFormat("en-US", { minimumFractionDigits: 2 }).format(tour.sixteen_guest) }}</div>
        </div>
      </div>
    </b-modal>
  </div>
</template>

<script>
// https://vuejsexamples.com/vue-js-lightbox-package-without-any-dependencies/
import CoolLightBox from 'vue-cool-lightbox';
import 'vue-cool-lightbox/dist/vue-cool-lightbox.min.css';
export default {
  components: {
    CoolLightBox,
  },

  data() {
    return {
      id: null,

      faqs: [
        // { q: 'Lorem ipsum dolor sit amet consectetur. Lorem eget diam a justo. Tellus nunc scelerisque ut ut sollicitudin integer porta amet.' },
        // { q: 'Lorem ipsum dolor sit amet consectetur. Lorem eget diam a justo. Tellus nunc scelerisque ut ut sollicitudin integer porta amet.' },
        // { q: 'Lorem ipsum dolor sit amet consectetur. Lorem eget diam a justo. Tellus nunc scelerisque ut ut sollicitudin integer porta amet.' },
        // { q: 'Lorem ipsum dolor sit amet consectetur. Lorem eget diam a justo. Tellus nunc scelerisque ut ut sollicitudin integer porta amet.' },
      ],

      index: null,
      gallery: [
        // { src: 'public/images/pages/tours/g-image-1.jpg' },
        // { src: 'public/images/pages/tours/g-image-2.jpg' },
        // { src: 'public/images/pages/tours/g-image-3.jpg' },
        // { src: 'public/images/pages/tours/g-image-4.jpg' },
        // { src: 'public/images/pages/tours/g-image-5.jpg' },
        // { src: 'public/images/pages/tours/g-image-6.jpg' },
      ],

      tour: {
        description: null,
      },

      tours: [
        // { image: 'public/images/pages/tours/tour-1.jpg', name: 'Cancun', price: 1000, oldPrice: 1200 },
        // { image: 'public/images/pages/tours/tour-2.jpg', name: 'Chichen Itza', price: 1223, oldPrice: 1400 },
        // { image: 'public/images/pages/tours/tour-3.jpg', name: 'Tulum', price: 1200, oldPrice: 1300 },
        // { image: 'public/images/pages/tours/tour-4.jpg', name: 'Playa de Carmen', price: 1100, oldPrice: 1200 },
        // { image: 'public/images/pages/tours/tour-2.jpg', name: 'Chichen Itza', price: 1223, oldPrice: 1400 },
      ],

      blog: [
        // { imageUrl: 'public/images/pages/blog/article-1.jpg', title: 'Your dream vacation awaits: Top tours in Cancun' },
        // { imageUrl: 'public/images/pages/blog/article-2.jpg', title: 'Must-see spots in Cancun' },
        // { imageUrl: 'public/images/pages/blog/article-3.jpg', title: 'The ultimate guide to touring Playa del Carmen' },
        // { imageUrl: 'public/images/pages/blog/article-4.jpg', title: 'Discover the magic of Mexico’s Rivera Maya' },
      ],

      products: [
        // { imageUrl: 'public/images/pages/products/product-1.jpg', name: 'Set snorkelling with snorket and diving googles' },
        // { imageUrl: 'public/images/pages/products/product-2.jpg', name: 'Sprinter diving fins' },
        // { imageUrl: 'public/images/pages/products/product-3.jpg', name: 'Waterproof camera shockproof for swimming underwater 1050 HD' },
        // { imageUrl: 'public/images/pages/products/product-4.jpg', name: 'Diving Dive Lights AL-18LED' },
      ],

      // == Carousels options ==
      bannersOptions: {
        loop: true,
        effect: 'fade',
        speed: 700,

        autoplay: {
          delay: 4000,
          disableOnInteraction: false
        },
      },

      relatedOptions: {
        slidesPerView: 3,
        spaceBetween: 10,

        pagination: {
          el: '.swiper-pagination',
          clickable: true,
          dynamicBullets: false
        },

        breakpoints: {
          1200: {
            slidesPerView: 3,
            spaceBetween: 10,

            pagination: {
              el: '.swiper-pagination',
              dynamicBullets: false
            }
          },
          768: {
            slidesPerView: 2,
            spaceBetween: 10,

            pagination: {
              el: '.swiper-pagination',
              dynamicBullets: true
            }
          },
          1: {
            slidesPerView: 1,
            spaceBetween: 10,

            pagination: {
              el: '.swiper-pagination',
              dynamicBullets: true
            }
          },
        }
      },
      // == ==
    }
  },

  methods: {
    setIndex(index) {
      this.index = index
    },

    getTour() {
      this.$root.isLoading = true;
      this.id = this.$root._getURLID(this.$route.params.id);

      axios.get(tools.url('/api/tour/'+this.id)).then((response)=>{
        this.tour = response.data;

        this.faqs = [
          { q: this.tour.add_on_one, pricePerson: this.tour.add_on_one_person_price, priceService: this.tour.add_on_one_service_price },
          { q: this.tour.add_on_two, pricePerson: this.tour.add_on_two_person_price, priceService: this.tour.add_on_two_service_price },
          { q: this.tour.add_on_three, pricePerson: this.tour.add_on_three_person_price, priceService: this.tour.add_on_three_service_price },
          { q: this.tour.add_on_four, pricePerson: this.tour.add_on_four_person_price, priceService: this.tour.add_on_four_service_price },
          { q: this.tour.add_on_five, pricePerson: this.tour.add_on_five_person_price, priceService: this.tour.add_on_five_service_price },
        ];
        this.$root.isLoading = false;
      });
    },

    getRelated() {
      axios.get(tools.url('/api/related-tours/'+this.id)).then((response)=>{
        this.tours = response.data;
      });
    },
  },
  
  mounted() {
    this.getTour();

    setTimeout(() => {
      this.getRelated();
    }, 500);
  },

  watch: { 
    '$route.params.id' (to, from){
      this.getTour();

      setTimeout(() => {
        this.getRelated();
      }, 500);
    }
  }
}
</script>
